// extracted by mini-css-extract-plugin
export default {"imageContainer":"imageContainer--dBDRd","trustlyMargin":"trustlyMargin--NHAhI"};